import { NavLink } from 'react-router';
import './ShellBottomNav.css';

// Subtle stroke icons — a single 1.5px weight across the set, drawn on a
// 24px grid so they line up with each other and sit calmly beside the label.
function NavIcon({ name }) {
  const common = {
    viewBox: '0 0 24 24',
    width: 22,
    height: 22,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.5,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };

  switch (name) {
    case 'home':
      return (
        <svg {...common}>
          <path d="M4 11.5 12 5l8 6.5" />
          <path d="M6 10.5V19h12v-8.5" />
          <path d="M10 19v-5h4v5" />
        </svg>
      );
    case 'most-read':
      return (
        <svg {...common}>
          <path d="M12 3c1.5 2.5 3.5 4 3.5 7a3.5 3.5 0 0 1-7 0c0-1 .3-1.8.8-2.6C10 8 11.5 6 12 3Z" />
        </svg>
      );
    case 'my-news':
      return (
        <svg {...common}>
          <path d="M5 4h14v17l-7-4-7 4Z" />
          <path d="M9 9h6M9 12h6" />
        </svg>
      );
    case 'games':
      return (
        <svg {...common}>
          <rect x="3" y="8" width="18" height="8" rx="4" />
          <path d="M7 12h3M8.5 10.5v3" />
          <circle cx="15.5" cy="11.5" r="0.5" fill="currentColor" />
          <circle cx="17" cy="13" r="0.5" fill="currentColor" />
        </svg>
      );
    case 'sections':
      return (
        <svg {...common}>
          <path d="M4 7h16M4 12h16M4 17h16" />
        </svg>
      );
    default:
      return null;
  }
}

const navItems = [
  { id: 'home', label: 'Home', path: '/', icon: 'home', active: true },
  { id: 'most-read', label: 'Most Read', path: '/most-read', icon: 'most-read', active: false },
  { id: 'my-news', label: 'My News', path: '/my-news', icon: 'my-news', active: true },
  { id: 'games', label: 'Games', path: '/games', icon: 'games', active: false },
  { id: 'sections', label: 'Sections', path: '/sections', icon: 'sections', active: false },
];

export function ShellBottomNav() {
  return (
    <nav className="shell-bottom-nav" aria-label="Primary">
      <ul className="shell-bottom-nav__list">
        {navItems.map((item) => {
          if (item.active) {
            return (
              <li key={item.id} className="shell-bottom-nav__item">
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    isActive
                      ? 'shell-bottom-nav__link shell-bottom-nav__link--active'
                      : 'shell-bottom-nav__link'
                  }
                  end={item.path === '/'}
                >
                  <span className="shell-bottom-nav__icon">
                    <NavIcon name={item.icon} />
                  </span>
                  <span className="shell-bottom-nav__label">{item.label}</span>
                </NavLink>
              </li>
            );
          }

          return (
            <li key={item.id} className="shell-bottom-nav__item">
              <button
                type="button"
                className="shell-bottom-nav__link"
                onClick={() => {
                  // Inactive items intentionally do nothing in the first prototype.
                }}
                aria-disabled="true"
              >
                <span className="shell-bottom-nav__icon">
                  <NavIcon name={item.icon} />
                </span>
                <span className="shell-bottom-nav__label">{item.label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
